import '../../personalisation/src/utilities/instrument';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { reactErrorHandler } from '@sentry/react';

import App from './App.tsx';
import { LocaleProvider } from './context/LocaleContext';
import { CartProvider } from './context/CartContext.tsx';

import './components/personalisation-global.css';

const container = document.getElementById('react-gwp-ui');

if (!container) {
  throw new Error('Container element with id "react-gwp-ui" not found');
}

createRoot(container, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: reactErrorHandler()
}).render(
  <StrictMode>
    <LocaleProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </LocaleProvider>
  </StrictMode>
);
